<template>
  <ux-form
    ref="form"
    class="certFicate-domain x-padding-x"
    :data="formData"
    :colon="true"
    :rules="rules"
    label-width="auto"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.certiFicate.password')" prop="password">
      <ux-input
        v-model="formData.password"
        :maxlength="20"
        :placeholder="$t('HT.certiFicate.password.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.certiFicate.certificate')" start prop="certificate">
      <el-upload
        class="upload-demo"
        ref="upload"
        action="#"
        :on-change="handleChange"
        accept=".jks"
        :file-list="fileList"
        :show-file-list="true"
        :auto-upload="false"
      >
        <ux-button slot="trigger" type="primary">{{ $t('HT.certiFicate.file') }}</ux-button>
        <div slot="tip" class="el-upload__tip">{{ $t('HT.certiFicate.file.tip') }}</div>
      </el-upload>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      obj: {
        name: 'hello',
        age: {}
      },
      formData: {
        certificate: '', //上传文件
        domain: this.data.domain, // 域名
        password: '' //输入的密匙
      },
      fileList: [],
      rules: this.$rul.Key()
    };
  },

  methods: {
    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
      this.formData.certificate = fileList[fileList.length - 1].raw;
      this.$refs['form'].validateField('certificate');
    },

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let list = new FormData();
          list.append('certificate', this.formData.certificate);
          list.append('domain', this.formData.domain);
          list.append('password', this.formData.password);
          this.$emit('confirm', list);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.certFicate-domain {
  width: 400px;
}
</style>
